module.exports = __webpack_public_path__ + "static/img/131.580ee314.gif";